import { collection, query, orderBy, updateDoc, where, doc, serverTimestamp } from "firebase/firestore";
import { db } from '../../firebase';

export const handleTingUpdate = async (tingDoc, tingId, options = {}) => {
    const { showAlert = true } = options;
    const q = doc(db, "posts", tingId);

    try {
        await updateDoc(q, {
            ...tingDoc, updatedTime: serverTimestamp(),
        })
        console.log('Ting Updated!');
        if (showAlert) {
            alert('Ting Updated!');
        }
        return true;
    }
    catch (error) {
        console.error('Error updating Ting:', error);
        if (showAlert) {
            alert(error);
        }
        return false;
    }

}
